import {
  useEffect,
  useRef
} from 'react'
import {
  Marker,
  useMap
} from 'react-leaflet'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { UNSUPPORTED_MAX_ZOOM_LEVEL } from 'utils/constants'
import { createEventMarkerColor } from 'utils/helpers'
import {
  markersSelectors,
  setCloseUserPanel,
  setEventId,
  setEventData,
  setSelectedEventData,
  usersSelectors
} from 'store'
import { v4 as uuid } from 'uuid'

export const EventMarkerItem = ({ eventItem }) => {
  const eventMarkerRef = useRef(null)
  const dispatch = useDispatch()
  let mouseDownOnMarkerRef = useRef(false)
  const { selectedEventData } = useSelector(markersSelectors)
  const { openPopupEvents } = useSelector(usersSelectors)

  const map = useMap()

  const [searchParams, setSearchParams] = useSearchParams()
  const eventid = eventItem?.id
  const eventIdParams = searchParams.get('eventid')

  const markerPostForPopup = () => {
    if (eventItem.lat >= 84.8) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, UNSUPPORTED_MAX_ZOOM_LEVEL)

      return 500
    }

    if (eventItem.lat >= 84.6) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, 21)

      return 500
    }

    if (eventItem.lat >= 83.6) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, 19)

      return 500
    }

    if (eventItem.lat >= 60) {
      // eslint-disable-next-line no-underscore-dangle
      map.setView(eventMarkerRef?.current?._latlng, 7)

      return 500
    }

    return 0
  }

  const handleClick = () => {
    dispatch(setEventId(null))
    dispatch(setSelectedEventData(null))
    dispatch(setEventData())
    setSearchParams({ eventid })

    const finalTimeout = markerPostForPopup()
    setTimeout(() => {
      dispatch(setEventId(eventItem?.id))
      dispatch(setSelectedEventData(eventItem))
    }, finalTimeout)
  }

  setTimeout(() => {
    if (
      +eventIdParams === eventid
      && eventMarkerRef.current
      && +sessionStorage.getItem('eventid') === eventid
      && selectedEventData?.id !== eventid
      && !openPopupEvents
    ) {
      const finalTimeout = markerPostForPopup()
      setTimeout(() => {
        dispatch(setEventId(eventItem.id))
        dispatch(setSelectedEventData(eventItem))
      }, finalTimeout)
    }
  }, 500)

  // issue as of now... lemme check
  useEffect(() => {
    if (
      +eventIdParams !== eventid
      && +sessionStorage.getItem('eventid') === eventid
      && eventMarkerRef.current
      && !openPopupEvents
      && (
        localStorage.getItem('isNotifOpen') === null
        || localStorage.getItem('isNotifOpen') === 'false'
      )
    ) {
      dispatch(setCloseUserPanel(true))
      setTimeout(() => dispatch(setCloseUserPanel(false)), 2000)
      setSearchParams({ eventid })
    }
  }, [])

  const eventIconMarker = createEventMarkerColor(eventItem?.start_date)

  return (
    <Marker
      zIndexOffset={100000000}
      key={uuid()}
      eventHandlers={{
        click: () => {
          if (eventItem?.lat < 84.5) {
            handleClick()
          }
        },
        mousedown: () => {
          mouseDownOnMarkerRef.current = true
        },
        mouseup: () => {
          if (mouseDownOnMarkerRef.current && eventItem?.lat >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        mouseout: () => {
          mouseDownOnMarkerRef.current = false
        },
        touchStart: () => {
          mouseDownOnMarkerRef.current = true
        },
        touchEnd: () => {
          if (mouseDownOnMarkerRef.current && eventItem?.lat >= 84.5) {
            handleClick()
          }

          mouseDownOnMarkerRef.current = false
        },
        touchCancel: () => {
          mouseDownOnMarkerRef.current = false
        }
      }}
      position={[eventItem?.lat, eventItem?.lng]}
      className="event-marker"
      icon={eventIconMarker}
      title={eventItem.id}
      ref={eventMarkerRef}
    />
  )
}
